<mat-nav-list>
  <mat-list-item>
    <div matLine>Game Admin</div>
  </mat-list-item>
  <hr class="white-text">
  <mat-expansion-panel>
    <mat-expansion-panel-header data-testid="manage-your-account-side-nav-option">
      <mat-panel-title>
        <mat-icon class="margin-right-med">account_circle</mat-icon>
        <span>Manage Your Account</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-list-item [routerLink]="['update-email-address']"
                   data-testid="navigate-to-change-email-page">
      <mat-icon matListItemIcon>email</mat-icon>
      <div matLine>Change Your Email</div>
    </mat-list-item>

    <mat-list-item [routerLink]="['update-password']"
                   data-testid="navigate-to-change-password-page">
      <mat-icon matListItemIcon>password</mat-icon>
      <div matLine>Change Your Password</div>
    </mat-list-item>
  </mat-expansion-panel>
  @if (activeGameId$ | async; as gameId) {
    <mat-list-item [routerLink]="[gameId, 'active-game-instances']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   data-testid="current-draw-page-link"
                   matTooltip="Current Draw"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>games</mat-icon>
      <div matLine data-testid="sidenav-current-draw">
        Current Draw
      </div>
    </mat-list-item>

    <mat-list-item [routerLink]="[gameId, 'manage-game']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   *hasPermission="permissionTypes.ViewGameSettings"
                   data-testid="manage-game-page-link"
                   matTooltip="Manage Game"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>settings</mat-icon>
      <div matLine data-testid="sidenav-game-settings">Game
        Settings
      </div>
    </mat-list-item>
    <mat-list-item [routerLink]="[gameId, 'game-admin-reporting']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   *hasPermission="permissionTypes.ViewReports"
                   data-testid="reports-page-link"
                   matTooltip="Reports"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>request_page</mat-icon>
      <div matLine data-testid="sidenav-reports">Reports
      </div>
    </mat-list-item>
    <mat-list-item [routerLink]="[gameId, 'manage-charities']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   data-testid="manage-charities-page-link"
                   *hasPermission="permissionTypes.ViewCharities"
                   matTooltip="Manage Charities"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>volunteer_activism</mat-icon>
      <div matLine data-testid="sidenav-charities">Charities
      </div>
    </mat-list-item>
    <mat-list-item [routerLink]="[gameId, 'game-admin-notification-preferences']"
                   data-testid="notification-preferences-page-link">
      <mat-icon matListItemIcon>volunteer_activism</mat-icon>
      <div matLine data-testid="sidenav-notification-preferences">Notification Preferences
      </div>
    </mat-list-item>
    <mat-list-item [routerLink]="[gameId, 'game-admin-winner-payouts']"
                   data-testid="view-winner-payout-page-link"
                   *hasPermission="permissionTypes.ViewWinnerPayouts">
      <mat-icon matListItemIcon>account_balance_wallet</mat-icon>
      <div matLine data-testid="sidenav-winner-payouts">Winner
        Payouts
      </div>
    </mat-list-item>
    <mat-list-item [routerLink]="[gameId, 'game-admin-charity-payouts']"
                   data-testid="view-charity-payout-page-link"
                   *hasPermission="permissionTypes.ViewCharityPayouts">
      <mat-icon matListItemIcon>payments</mat-icon>
      <div matLine data-testid="sidenav-charity-payouts">Charity
        Payouts
      </div>
    </mat-list-item>
    <mat-list-item [routerLink]="[gameId, 'player-search']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   data-testid="player-search-page-link"
                   *hasPermission="permissionTypes.ViewPlayerInfo"
                   matTooltip="Manage Players"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>manage_accounts</mat-icon>
      <div matLine data-testid="sidenav-players">Players
      </div>
    </mat-list-item>
    <mat-list-item [routerLink]="[gameId, 'payment-methods']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   data-testid="payment-methods-page-link"
                   *hasPermission="permissionTypes.ViewPlayerInfo"
                   matTooltip="Payment Methods"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>credit_card</mat-icon>
      <div matLine data-testid="sidenav-payment-methods">Payment Methods
      </div>
    </mat-list-item>
    <mat-list-item [routerLink]="['email-history']"
                   *hasPermission="permissionTypes.ViewPlayerInfo"
                   data-testid="email-history">
      <mat-icon matListItemIcon>email</mat-icon>
      <div matLine data-testid="sidenav-email-history">Email History</div>
    </mat-list-item>
    @if (gameDrawnManually$ | async) {
      <mat-list-item [routerLink]="[gameId, 'draw-winner']"
                     [matTooltipDisabled]="sideNavShouldOpen"
                     data-testid="draw-winner-page-link"
                     *hasPermission="permissionTypes.DrawGameWinner"
                     matTooltip="Draw Winner"
                     matTooltipPosition="right">
        <mat-icon matListItemIcon>celebration</mat-icon>
        <div matLine data-testid="sidenav-draw-winner">Draw Winner</div>
      </mat-list-item>
    }

      <mat-list-item [routerLink]="[gameId, 'game-admin-support-desk-search']"
                     [matTooltipDisabled]="sideNavShouldOpen"
                     data-testid="game-support-desk-page-link"
                     *hasPermission="permissionTypes.ViewSupportRequests"
                     matTooltip="Support Desk"
                     matTooltipPosition="right">
        <mat-icon matListItemIcon
                  [matBadge]="assignedSupportRequestsCount()"
                  matBadgeColor="warn"
                  [matBadgeHidden]="assignedSupportRequestsCount() === 0">
          support_agent
        </mat-icon>
        <div matLine data-testid="sidenav-game-support-desk">Support Desk</div>
      </mat-list-item>

    <mat-list-item [routerLink]="[gameId, 'manage-game-admin-users']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   data-testid="manage-users-page-link"
                   *hasPermission="permissionTypes.ViewAdminUsers"
                   matTooltip="Admin Users"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>supervised_user_circle</mat-icon>
      <div matLine>Admin Users</div>
    </mat-list-item>

    <mat-list-item [routerLink]="['player-email-confirmations']"
                   data-testid="player-email-confirmations-page-link"
                   *hasPermission="permissionTypes.ViewEmailConfirmations">
      <mat-icon matListItemIcon>email</mat-icon>
      <div matLine data-testid="sidenav-player-email-confirmations">Player Email Confirmations</div>
    </mat-list-item>

    <mat-list-item [routerLink]="[gameId, 'manage-broadcast-notifications']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   data-testid="manage-broadcast-notifications-page-link"
                    *hasPermission="permissionTypes.ViewBroadcastNotifications"
                   matTooltip="Broadcast Notifications"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>campaign</mat-icon>
      <div matLine data-testid="sidenav-broadcast-notifications">Broadcast Notifications</div>
    </mat-list-item>

    <mat-list-item [routerLink]="['failed-refunds']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   data-testid="failed-refunds-page-link"
                   *hasPermission="permissionTypes.ViewFailedRefunds"
                   matTooltip="Failed Refunds"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>error</mat-icon>
      <div matLine data-testid="sidenav-failed-refunds">Failed Refunds</div>
    </mat-list-item>

    <mat-list-item [routerLink]="[gameId, 'frequently-asked-questions']"
                   data-testid="faq-page-link">
      <mat-icon matListItemIcon>question_mark</mat-icon>
      <div matLine data-testid="sidenav-faq">Frequently Asked Questions</div>
    </mat-list-item>

  }

  @if ((availableGamesToUser$ | async)?.length! > 1) {
    <mat-list-item [routerLink]="['']"
                   [matTooltipDisabled]="sideNavShouldOpen"
                   data-testid="change-game-page-link"
                   matTooltip="Change Game"
                   matTooltipPosition="right">
      <mat-icon matListItemIcon>home</mat-icon>
      <div matLine data-testid="sidenav-change-game">Landing
      </div>
    </mat-list-item>
  }

  <mat-list-item data-testid="user-menu-logout-button" (click)="onLogoutClick();">
    <mat-icon matListItemIcon>logout</mat-icon>
    <div matLine>Log out</div>
  </mat-list-item>

</mat-nav-list>
